import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import PIIView from '../views/PIIFormView.vue'
import DoneView from '../views/DoneView.vue'
import {getNextRoute} from '@/hooks/useStatusCheck'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      progress: 1,
    },
  },
  {
    path: '/pii',
    name: 'pii',
    component: PIIView,
    meta: {
      progress: 2,
    },
  },
  {
    path: '/done',
    name: 'done',
    component: DoneView,
    meta: {
      progress: 3,
      hideSafaltaLogo: true,
    },
  },

]

const router = createRouter({
  history: createWebHistory('/safalta-app/participant-app/'),
  routes
})


function triggerGa(to, from, next){
	if(window.fbq){
		fbq('init', '1632340997052628');
		fbq('track', 'PageView');
	}
	if(window.ga){
		ga('set', 'page', to.path)
		console.log('set', 'page', to.path)
		ga('send', 'pageview')
		console.log('send', 'pageview')
	}
	next && next()
}

async function statusCheck(to, from, next){
  const statusCheckRoutes = ['pii', 'done']
  if(window.safalta_config && window.safalta_config.IS_LOGGED_IN && window.safalta_config.IS_PARTICIPANT){
    statusCheckRoutes.push('home')
  }
  if(statusCheckRoutes.includes(to.name)){
    const nextRoute = await getNextRoute()
    console.log({nextRoute})
    if(nextRoute !== to.name){
      next(nextRoute)
    }else {
      next()
    }
  }else {
    next()
  }
}

router.afterEach(triggerGa)
router.beforeEach(statusCheck)

export default router
